import httpStatus from 'http-status-codes';

export default class SessionService {

    $api;
    key = 'login-session';
    last_selected_key = 'last-selected';
    favourites = 'favourites-'

    constructor(api) {
        this.$api = api;
    }

    is_permanent() {
        return !!localStorage.getItem(this.key)
    }

    storage() {
        return this.is_permanent()
            ? localStorage
            : sessionStorage;
    }

    get() {
        return localStorage.getItem(this.key)
            ? localStorage.getItem(this.key)
            : sessionStorage.getItem(this.key);
    }

    store(session, remember) {
        if (remember) {
            localStorage.setItem(this.key, session);
            sessionStorage.removeItem(this.key);
        } else {
            sessionStorage.setItem(this.key, session);
            localStorage.removeItem(this.key);
        }
    }

    remove() {
        localStorage.removeItem(this.key);
        sessionStorage.removeItem(this.key);
    }

    get_last() {
        return localStorage.getItem(this.last_selected_key);
    }

    store_last(resource_id) {
        localStorage.setItem(this.last_selected_key, resource_id);
    }

    remove_last() {
        localStorage.removeItem(this.last_selected_key);
    }

    get_favourites(applicationId) {
        const items = this.storage().getItem(`${this.favourites}${applicationId}`);
        return items ? items.split(',') : [];
    }

    set_favourites(applicationId, items) {
        if (items && items.length) {
            this.storage().setItem(`${this.favourites}${applicationId}`, items.join(','));
        } else {
            this.storage().removeItem(`${this.favourites}${applicationId}`);
        }
    }

    add_favourites(applicationId, item) {
        const items = this.get_favourites(applicationId);
        if (items.indexOf(item) === -1) {
            items.push(item);
        }
        this.set_favourites(applicationId, items);
    }

    remove_favourites(applicationId, item) {
        const items = this.get_favourites(applicationId)
            .filter((favourite) => favourite !== item);
        this.set_favourites(applicationId, items);
    }

    exists() {
        return this.get() !== null;
    }

    get headers() {
        return {
            Authorization: `Bearer ${this.get()}`
        };
    }

    authenticate(login, password, remember) {
        return this.$api.post(
            "/login/password",
            {
                'login': login,
                'password': password,
            }
        ).then(
            response => {
                this.store(response.data.login, remember);
                return response;
            }
        );
    }

    logout() {
        return this.$api.put(
            "/sessions/logout",
            {},
            {
                headers: this.headers,
                validateStatus: status => status === httpStatus.OK
            }
        ).then(
            response => {
                return response;
            }
        ).catch((error) => {
            throw error
        });
    }

    isLogged() {
        return this.exists() ?
            this.current()
                .then(
                    () => {
                        Promise.resolve()
                    }
                )
                .catch(
                    () => {
                        this.remove();
                        return Promise.reject()
                    }
                )
            : Promise.reject();
    }

    current() {
        return this.$api.get("/sessions/current",
            {
                headers: this.headers,
                validateStatus: status => status === httpStatus.OK
            }
        ).then(response => response.data)
            .catch(() => Promise.reject());
    }

    update(data) {
        return this.$api.put(
            "/sessions/current",
            data,
            {
                headers: this.headers,
                validateStatus: status => status === httpStatus.OK
            }
        ).then(
            response => {
                return response;
            }
        ).catch((error) => {
            throw error
        });
    }

    applications() {
        return this.$api.get("/sessions/current/applications",
            {
                headers: this.headers,
                validateStatus: status => status === httpStatus.OK
            }
        ).then(response => response.data)
            .catch(() => Promise.reject());
    }

    resources(applicationId) {
        return this.$api.get(`/sessions/current/applications/${applicationId}/resources`,
            {
                headers: this.headers,
                validateStatus: status => status === httpStatus.OK
            }
        ).then(response => response.data)
            .catch((error) => {
                throw error
            })
    }

    passwordReset(login) {
        return this.$api.post(
            "/password/reset",
            {
                'login': login,
            }
        ).then(
            response => {
                this.store(response.data.login);
                return response;
            }
        ).catch((error) => {
            throw error
        });
    }

    getPasswordRestore(token) {
        return this.$api.get(
            `/password/restore/${token}`
        ).then(
            response => {
                return response;
            }
        ).catch((error) => {
            throw error
        });
    }

    passwordChange(data) {
        return this.$api.put(
            "/password",
            data
        ).then(
            response => {
                return response;
            }
        ).catch((error) => {
            throw error
        });
    }

}
